<div class="wrapper-reponsive">
    <!-- Start màn 10 -->
    <div class="tlt-green-row mt-3">
        {{'STR_MEDICAL_EXAM_RESERVATION' | translate}}
    </div>
    <div class="content-box mt-2 mb-3 p-3" *ngIf="typeMode !== 3">
        <div class="process-step">
            <p>Step</p>
            <ul>
                <li class="active">
                    <div class="circle">
                        <span class="num">1</span>
                    </div>
                </li>
                <li class="active">
                    <div class="circle">
                        <span class="num">2</span>
                    </div>
                </li>
                <li class="active">
                    <div class="circle">
                        <span class="num">3</span>
                    </div>
                </li>
                <li class="active">
                    <div class="circle">
                        <span class="num">4</span>
                    </div>
                </li>
                <li class="active">
                    <div class="circle">
                        <span class="num">5</span>
                    </div>
                </li>
                <li>
                    <div class="circle">
                        <span class="num">6</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="content-box mt-2 mb-2">
        <div class="tlt-border mb-3">
            {{'STR_SELECT_RSV_DATETIME' | translate}}
        </div>
        <div class="box-common mb-2">
            <div class="tlt-dot m-0">
                {{'STR_RSV_DAY' | translate}}
                <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                <p class="pb-1">{{'STR_PLEASE_SELECT_RESERVATION_DATE' | translate}}</p>
            </div>
            <div class="box-desc">
                <span class="mr-3">
                    <span style="color: #1DCD80;">●</span>：{{'STR_FREE_FRAME' | translate}}
                </span>
                <span class="mr-3">×：{{'STR_NO_FREE_FRAME' | translate}}</span>
                <span>{{'STR_NON_BUSINESSDAY_COLOR' | translate}}</span>
            </div>
            <div class="date-box">
                <div class="button-calendar">
                    <div class="ngb-dp-arrow">
                        <button type="button" class="btn btn-link ngb-dp-arrow-btn" (click)="changeMonthCalendar(-1)"
                            [disabled]="disabledPrev">
                            <span class="ngb-dp-navigation-chevron"></span>
                        </button>
                    </div>
                    <div class="ngb-dp-arrow right">
                        <button type="button" class="btn btn-link ngb-dp-arrow-btn" (click)="changeMonthCalendar(1)"
                            [disabled]="disabledNext">
                            <span class="ngb-dp-navigation-chevron"></span>
                        </button>
                    </div>
                </div>
                <div class="custom-weekday-frame">
                    <div role="columnheader" class="ngb-dp-weekday small">{{'STR_MONDAY' | translate}}</div>
                    <div role="columnheader" class="ngb-dp-weekday small">{{'STR_TUESDAY' | translate}}</div>
                    <div role="columnheader" class="ngb-dp-weekday small">{{'STR_WEDNESDAY' | translate}}</div>
                    <div role="columnheader" class="ngb-dp-weekday small">{{'STR_THURSDAY' | translate}}</div>
                    <div role="columnheader" class="ngb-dp-weekday small">{{'STR_FRIDAY' | translate}}</div>
                    <div role="columnheader" class="ngb-dp-weekday small text-saturday">{{'STR_SATURDAY' | translate}}
                    </div>
                    <div role="columnheader" class="ngb-dp-weekday small text-sunday">{{'STR_SUNDAY' | translate}}</div>
                </div>
                <ngb-datepicker #dp navigation="arrows" [showWeekNumbers]="false" [dayTemplate]="customDay"
                    class="datepicker-custom datepicker-option datepicker-custom-frame"
                    (dateSelect)="selectDate($event, false)" [markDisabled]="isDisabled" [minDate]="minDate">
                </ngb-datepicker>
                <ng-template #customDay let-date let-currentMonth="currentMonth" let-selected="selected"
                    let-disabled="disabled" let-focused="focused">
                    <div [class.bg-selected]="getSelectedDate(date)" [class.focused]="focused"
                        [class.outside]="date.month !== currentMonth">
                        <div class="date-custom">
                            <!-- 20241128 modify #23420 start -->
                            <!-- <span class="custom-day" [class.text-current-month]="date.month !== currentMonth"
                                [class.text-muted]="disabled">
                                {{ date.day }}
                            </span> -->
                            <span class="custom-day" [class.text-current-month]="date.month !== currentMonth"
                                [class.text-muted]="disabled" [class.bg-holiday]="getNationalHoliday(date)">
                                {{ date.day }}
                            </span>
                            <!-- 20241128 modify #23420 end -->
                        </div>
                        <div class="icon-custom">
                            <!-- 20230915 modify #19712 start -->
                            <!-- <span [class.hidden]="date.month !== currentMonth" [class.icon-valid]="getDay(date, 1)"
                                [class.icon-invalid]="getDay(date, 0)">
                            </span> -->
                            <!-- 20241129 modify #23420 start -->
                            <!-- <span [class.hidden]="date.month !== currentMonth || disabled" [class.icon-valid]="getDay(date, 1)"
                                [class.icon-invalid]="getDay(date, 0)">
                            </span> -->
                            <span [class.hidden]="date.month !== currentMonth || disabled" [class.icon-valid]="getDay(date, 1)"
                                [class.icon-invalid]="getDay(date, 0)" [class.bg-holiday]="getNationalHoliday(date)">
                            </span>
                            <!-- 20241129 modify #23420 end -->
                            <!-- 20230915 modify #19712 end -->
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
        <div class="box-common mb-4" *ngIf="!util.isNullOrEmpty(objRsvDateTime?.RsvYMD)">
            <div class="tlt-dot m-0">
                {{'STR_RESERVATION_TIME' | translate}}
                <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                <p class="pb-2">
                    {{'STR_EXPLAIN_SELECT_TIME' | translate}}<br>
                    {{'STR_PLEASE_SELECT_TIME' | translate}}
                </p>
            </div>
            <div class="form-row-2">
                <div class="col-item" *ngFor="let item of listReservationSelect; let k = index" [ngClass]="{'active': item.Checked, 'disabledItem': getDisabledItem(item)}">
                    <label class="custom-radio">
                        {{item.RsvTime | TimePipe}}
                        <input type="radio" name="radio" [checked]="item.Checked" (click)="changeSelectTime(item)"
                            [disabled]="getDisabledItem(item)">
                        <span class="checkmark"></span>
                    </label>
                </div>
                <ng-container *ngIf="listReservationSelect?.length % 3 === 0">
                    <div class="col-item no-hover">
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="text-center lst-button-flex mt-2">
            <button class="btn btn-common btn-bg-yellow mr-2 ml-2 mb-2" (click)="ButtonBack()">
                {{'STR_BTN_BACK' | translate}}
            </button>
            <button class="btn btn-common btn-bg-green mr-2 ml-2 mb-2" [disabled]="checkDisableNext()" (click)="ButtonNext()"
                *ngIf="typeMode === 1">
                {{'STR_BTN_THE_NEXT' | translate}}
            </button>
            <button class="btn btn-common btn-bg-green mr-2 ml-2 mb-2" [disabled]="checkDisableNext() || !checkChangeData()" *ngIf="typeMode !== 1" (click)="ButtonEdit()">
                {{'STR_BTN_EDIT' | translate}}
            </button>
        </div>
    </div>
    <!-- End màn 10 -->
</div>